import { Component, OnDestroy, ViewChild, TemplateRef, Input, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { TabComponent } from '../../../../../Common/Layout/components/Tab/tab.component';
import { EmailRecipientSearchService } from './email-recipient-search.service';
import { FilterService } from '../../../../../Common/Filter/services/abstract-filter.service';
import { EmailRecipientModel } from '../../../../../Common/TargetingShared/model/statisticsReport/email-recipient.model';
import { messageSeverityEnum } from '../../../../../Common/Misc/enums/message-severity.enum';
import { BriefingDeliveryMethodEnum } from '@Monitor/Briefings/enums/briefing-delivery-method.enum';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { ShareCanvasDialogComponent } from './ShareCanvasDialog/share-canvas-dialog.component';
import { BriefingsService } from '../../../services/briefings.service';
import { BriefingModel } from '@Monitor/Briefings/models/briefing.model';


@Component({
    selector: 'agpr-email-recipient-search-tab',
    templateUrl: './email-recipient-search-tab.component.html',
    styleUrls: ['./email-recipient-search-tab.component.scss'],
    providers: [
        {
            provide: TabComponent,
            useExisting: EmailRecipientSearchTabComponent
        },
        {
            provide: 'PaginatorServiceInterface',
            useExisting: EmailRecipientSearchService
        },
        {
            provide: FilterService,
            useExisting: EmailRecipientSearchService
        },
        {
            provide: 'SortOrderServiceInterface',
            useExisting: EmailRecipientSearchService
        }
    ],
    standalone: false
})
export class EmailRecipientSearchTabComponent extends TabComponent implements OnInit, OnDestroy {
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly buttonTypes = ButtonTypesEnum;
    readonly briefingDeliveryMethodEnum = BriefingDeliveryMethodEnum;

    @Input() briefingType?: BriefingDeliveryMethodEnum;

    private subscriptions: Subscription[] = [];

    loading: boolean = false;
    briefing: BriefingModel;
    recipients: EmailRecipientModel[] = [];

    @ViewChild('tabHeader') declare _header: TemplateRef<any>;

    public get header(): TemplateRef<any> {
        return this._header;
    }
    public set header(value: TemplateRef<any>) {
        this._header = value;
    }

    id: string = 'emailRecipientSearch';

    constructor(
        private coreDialogService: CoreDialogService,
        private briefingsService: BriefingsService,
        private emailRecipientSearchService: EmailRecipientSearchService
    ) {
        super();
    }

    ngOnInit() {
        this.subscriptions.push(
            this.briefingsService.getFocusedResource().subscribe(briefing => {
                this.briefing = briefing;
            }),
            this.emailRecipientSearchService.results$.subscribe(results => {
                this.recipients = results;
            })
        );
    }

    openSendNotificationDialog() {
        this.coreDialogService.open(ShareCanvasDialogComponent, {
            inputs: {
                briefing: this.briefing,
                recipients: this.recipients
            },
            outputs: {
                dialogClose: () => {
                    // TODO: This part will be finished in NEP-33012
                }
            }
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
